<template>
	<div class="board">
		<table>
			<tr v-for="(row, i) in board.rows" :key="i">
				<td
					v-for="(col, j) in splitRow(row)"
					:key="j"
					:style="{
						backgroundColor: col === '' ? '#ffffff' : color,
					}"
				>
					{{ col }}
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
export default {
	name: "Board",
	props: {
		board: {
			type: Object,
			required: true,
		},
		color: {
			type: String,
			default: "#bf45f3",
		},
	},
	data() {
		return {};
	},
	methods: {
		splitRow(row) {
			return row.split(",").map((item) => item.replace("·", ""));
		},
	},
};
</script>

<style lang="scss" scoped src="./styles.scss"></style>
